import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { CLIENT_ROLES, homePath } from "./lib/api";
import Login from "./pages/Login";
import Landing from "./pages/Landing";
import SetPassword from "./pages/SetPassword";
import PortalLayout from "./components/PortalLayout";
import Dashboard from "./pages/Dashboard";
import Projects from "./pages/Projects";
import Documents from "./pages/Documents";
import Deliverables from "./pages/Deliverables";
import Compliance from "./pages/Compliance";
import Reports from "./pages/Reports";
import AICfo from "./pages/AICfo";
import Tickets from "./pages/Tickets";
import Team from "./pages/Team";
import Finance from "./pages/Finance";
import Meetings from "./pages/Meetings";
import Messages from "./pages/Messages";
import Settings from "./pages/Settings";
import AdminLayout from "./components/AdminLayout";
import AdminOverview from "./pages/admin/AdminOverview";
import AdminClients from "./pages/admin/AdminClients";
import AdminAgents from "./pages/admin/AdminAgents";
import AdminTasks from "./pages/admin/AdminTasks";
import AdminTickets from "./pages/admin/AdminTickets";
import AdminReports from "./pages/admin/AdminReports";
import AdminLeads from "./pages/admin/AdminLeads";
import AdminJobRequests from "./pages/admin/AdminJobRequests";
import AgentLayout from "./components/AgentLayout";
import AgentWorkspace from "./pages/agent/AgentWorkspace";
import AgentDashboard from "./pages/agent/AgentDashboard";
import { AgentDocuments } from "./pages/agent/AgentDocuments";
import { AgentCompliance, AgentMessages, AgentBookkeeping, AgentTickets } from "./pages/agent/AgentPages";
import Bookkeeping from "./pages/Bookkeeping";
import AdminTeam from "./pages/admin/AdminTeam";

function Protected({ roles, children }) {
  const { user } = useAuth();
  if (user === null) return <div className="min-h-screen flex items-center justify-center label">Loading…</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (roles && !roles.includes(user.role)) return <Navigate to={homePath(user.role)} replace />;
  return children;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <Toaster position="bottom-right" theme="light" richColors />
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/set-password" element={<SetPassword />} />
            <Route path="/" element={<Landing />} />

            <Route element={<Protected roles={CLIENT_ROLES}><PortalLayout /></Protected>}>
              <Route path="dashboard" element={<Dashboard />} />
              <Route path="projects" element={<Projects />} />
              <Route path="bookkeeping" element={<Bookkeeping />} />
              <Route path="documents" element={<Documents />} />
              <Route path="deliverables" element={<Deliverables />} />
              <Route path="compliance" element={<Compliance />} />
              <Route path="reports" element={<Reports />} />
              <Route path="finance" element={<Finance />} />
              <Route path="meetings" element={<Meetings />} />
              <Route path="messages" element={<Messages />} />
              <Route path="ai-cfo" element={<AICfo />} />
              <Route path="tickets" element={<Tickets />} />
              <Route path="team" element={<Team />} />
              <Route path="settings" element={<Settings />} />
            </Route>

            <Route path="/admin" element={<Protected roles={["admin"]}><AdminLayout /></Protected>}>
              <Route index element={<AdminOverview />} />
              <Route path="clients" element={<AdminClients />} />
              <Route path="agents" element={<AdminAgents />} />
              <Route path="tasks" element={<AdminTasks />} />
              <Route path="tickets" element={<AdminTickets />} />
              <Route path="reports" element={<AdminReports />} />
              <Route path="leads" element={<AdminLeads />} />
              <Route path="job-requests" element={<AdminJobRequests />} />
              <Route path="team" element={<AdminTeam />} />
            </Route>

            <Route path="/agent" element={<Protected roles={["agent"]}><AgentLayout /></Protected>}>
              <Route index element={<AgentDashboard />} />
              <Route path="jobs" element={<AgentWorkspace />} />
              <Route path="bookkeeping" element={<AgentBookkeeping />} />
              <Route path="documents" element={<AgentDocuments />} />
              <Route path="compliance" element={<AgentCompliance />} />
              <Route path="messages" element={<AgentMessages />} />
              <Route path="meetings" element={<Meetings />} />
              <Route path="tasks" element={<AgentTickets />} />
              <Route path="team" element={<Team />} />
              <Route path="settings" element={<Settings />} />
            </Route>
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
